import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// Constants
import { TRANSACTION_SORT_DATE_FILTER } from 'common/constants/filters'

// Assets
import { FilterIcon } from 'assets/images/Icons'

// Store
import { actions } from 'core/store'

// Styled Elements
import { TableFilterFormWrapper, DropwdownFilterWrapper, Divider } from '../Filter.elements'

// Components
import { SimpleSelect, DateRangePicker, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = (dispatch) => actions(dispatch)

function TransactionTableFilter(props) {
  // Destructure
  const { filters, actions } = props
  const { transactionFilters } = filters
  const { sort, start_range, end_range } = transactionFilters

  // Store Actions
  const { setTransactionFilters } = actions

  // Functions
  // Filter Functions
  const handleDateSelect = async ({ start, end }) => {
    await setTransactionFilters({
      ...transactionFilters,
      start_range: start,
      end_range: end,
      page: 1,
    })
  }
  const handleSortSelect = async (value) => {
    if (sort !== value) {
      await setTransactionFilters({ ...transactionFilters, sort: value })
    }
  }

  return (
    <TableFilterFormWrapper>
      <UncontrolledDropdown direction="down">
        <DropdownToggle>
          <Button
            variant="outlined"
            size="small"
            startIcon={<FilterIcon size={14} />}
          >
            Filter
          </Button>
        </DropdownToggle>
        <DropdownMenu style={{ minWidth: '300px' }}>
          <DropwdownFilterWrapper>
            <DateRangePicker
              id="addressDateFilter"
              key={start_range}
              onApply={handleDateSelect}
              start={start_range}
              end={end_range}
              vertical
            />

            <Divider />

            <SimpleSelect
              id="travelRuleSort"
              label="Sort By: "
              options={TRANSACTION_SORT_DATE_FILTER}
              onChange={handleSortSelect}
              value={sort}
              vertical
            />
          </DropwdownFilterWrapper>
        </DropdownMenu>
      </UncontrolledDropdown>
    </TableFilterFormWrapper>
  )
}

// Default Props
TransactionTableFilter.defaultProps = {
  filters: {},
  actions: {},
}

// Proptypes Validation
TransactionTableFilter.propTypes = {
  filters: PropTypes.shape({
    transactionFilters: PropTypes.shape({
      sort: PropTypes.string,
      account_type_id: PropTypes.number,
      page_index: PropTypes.number,
      start_range: PropTypes.string,
      end_range: PropTypes.string,
    }),
  }),
  actions: PropTypes.shape({
    setShowHeaderLoader: PropTypes.func,
    setTransactionFilters: PropTypes.func,
    toggleUpgradeModal: PropTypes.func,
    setInfoModalDetails: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionTableFilter)
